import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { Modul } from '../../../core/enums/modul';
import { Permission } from '../../../core/enums/permission';
import { BauherrHelper } from '../../../core/helper/bauherr.helper';
import { RechteService } from '../../../core/http/rechte.service';
import { DokumentBezeichnungDto } from '../../../core/models/base/dokument-bezeichnung-dto.model';
import { ProjektDto } from '../../../core/models/projekt/projekt-dto.model';
import { NoPermissionComponent } from '../../../shared/modals/info/info.component';
import { PrSelectionComponent } from '../../../shared/modals/pr-selection/pr-selection.component';
import { DashboardCardComponent } from '../../dashboard/dashboardcard.component';

@Component({
  selector: 'bpw-bj-dashboardcard',
  standalone: true,
  templateUrl: './bj-dashboardcard.component.html',
  styleUrls: ['./bj-dashboardcard.component.scss'],
})
export class BjDashboardcardComponent implements DashboardCardComponent {
  private readonly _router = inject(Router);
  private readonly _rechteService = inject(RechteService);
  private readonly _modalService = inject(MdbModalService);

  @Input()
  public data: any;
  public visible: boolean;

  constructor() {
    this.visible = false;
  }

  public openBaujournalOverview(): void {
    if (this.data && this.data.id) {
      this._router.navigateByUrl(`baujournal/${this.data.id}`);
    } else {
      this._router.navigateByUrl(`baujournal`);
    }
  }

  public createBaujournal(): void {
    this._rechteService
      .hasRight(Modul.Bj, Permission.Neu)
      .then((hasRight) => {
        if (hasRight) {
          let searchTerm = '';
          if (this.data) {
            searchTerm = this.data.dokument;
          }

          this._modalService
            .open(PrSelectionComponent, { data: { searchTerm } })
            .onClose.subscribe((pr: DokumentBezeichnungDto) => {
              if (pr) {
                this._router.navigateByUrl(`baujournal/${pr.id}/neu`);
              }
            });
        } else {
          this._modalService.open(NoPermissionComponent, { ignoreBackdropClick: true });
        }
      })
      .catch(() => {
        this._modalService.open(NoPermissionComponent, { ignoreBackdropClick: true });
      });
  }

  public getBauherr(projekt: ProjektDto): string | undefined {
    return BauherrHelper.getBauherrByProjektDto(projekt);
  }
}
